import { render, staticRenderFns } from "./IPAddress.vue?vue&type=template&id=b67f0006&scoped=true&lang=pug&"
import script from "./IPAddress.vue?vue&type=script&lang=js&"
export * from "./IPAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b67f0006",
  null
  
)

export default component.exports